// extracted by mini-css-extract-plugin
module.exports = {"code":"offer-coupon_code_DeX3P"};